<template>
  <div class="group-listing">
    <div class="mb-12">
      <v-row class="flex-column flex-md-row">
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center"
          >
            Custom Offline Trip
          </v-card-title>
        </v-col>
      </v-row>
      <validation-observer ref="validator">
        <v-form @submit.prevent="submit()">
          <v-row>
            <v-col sm="12" lg="7">
              <v-container fluid class="mx-1060">
                <v-row>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        name="name"
                        :error-messages="errors"
                        v-model="request.name"
                        label="Trip Name"
                        required
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <validation-provider
                      name="tourism_operator_id"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-select
                        class="notranslate"
                        :menu-props="{ contentClass: 'notranslate' }"
                        name="tourism_operator_id"
                        :items="operators"
                        item-text="full_name"
                        :error-messages="errors"
                        item-value="id"
                        v-model="request.tourism_operator_id"
                        label="Operator"
                        @change="handleOperatorChange"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <validation-provider
                      name="tour_id"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-select
                        :menu-props="{ contentClass: 'notranslate' }"
                        name="tour_id"
                        :items="typesByOperator"
                        item-text="name"
                        :error-messages="errors"
                        item-value="id"
                        v-model="request.tour_id"
                        label="Tours"
                        :disabled="!request.tourism_operator_id"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <DatePicker
                      name="check_in"
                      rules="required"
                      v-model="request.check_in"
                      label="Check in date"
                      class="mb-6"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <DatePicker
                      name="check_out"
                      rules="required|after:@check_in,true"
                      v-model="request.check_out"
                      label="Check out date"
                      :min="request.check_in"
                      class="mb-6"
                    />
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 6"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <ValidationProvider
                      name="project_id"
                      label="Project"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <v-autocomplete
                        class="notranslate"
                        :menu-props="{ contentClass: 'notranslate' }"
                        :disabled="!request.tour_id"
                        v-model="request.project_id"
                        :items="validProjects"
                        :multiple="false"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors"
                        label="Projects"
                        append-icon="$expand"
                        color="black"
                        name="project"
                      >
                        <template v-slot:item="data">
                          <template>
                            <v-list-item-avatar>
                              <img
                                class="w-50px"
                                :src="
                                  formatImageUrlFromMediaUrl(
                                    getMedia(data.item)
                                  )
                                "
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="data.item.name"
                              ></v-list-item-title>
                              <v-list-item-subtitle
                                v-html="truncate(data.item.description)"
                              ></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col
                    class="pr-md-7 pl-md-5"
                    :lg="rightDrawer.opened ? 12 : 12"
                    :md="rightDrawer.opened ? 12 : 12"
                  >
                    <MemberSightings
                      v-if="
                        loggedInUser &&
                          ((isEditMode && isDataFetched) || !isEditMode)
                      "
                      :index="0"
                      :member="loggedInUser"
                      :request="request"
                      :is-edit-mode="isEditMode"
                    />
                    <div class="mb-10">
                      <span
                        v-if="!hasSpecies"
                        id="species-error"
                        :class="speciesClass"
                      >
                        Please Select Species
                      </span>
                      <span
                        v-if="!request.amount > 0"
                        id="amount"
                        :class="speciesClass"
                      >
                        Please Add Amount
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col>
              <div class="position-fixed"></div>
            </v-col>
          </v-row>
        </v-form>
      </validation-observer>
      <v-card-actions class="flex-column flex-md-row px-5 custom-trips-button">
        <v-btn
          large
          color="white"
          class="elevation-1 font-weight-bold px-8 mr-10"
          min-width="275px"
          @click="goToList()"
        >
          Cancel
        </v-btn>
        <v-btn
          large
          color="primary"
          class="elevation-1 font-weight-bold px-8"
          min-width="275px"
          @click.prevent="submit()"
          :loading="request.submitting"
          :disabled="request.submitting || (!request.id && request.submitted)"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Request from '@request/CustomGroupRequest';
import Model from '@models/Group';
import TourRequest from '@request/TourRequest';
import Storage from '@services/Storage';
import { StoreNames } from '@constants/storage';
import { uuid } from 'uuidv4';
import { formatImageUrlFromMediaUrl } from '@/utils';
import { getPromise } from '@services/Promise';
import { isOnline } from '@helpers';
import TourModel from '@models/Tour';
import Project from '@models/Project';

const elementStyle = {};

const storage = new Storage();

export default {
  name: 'CreateOfflineTrip',
  metaInfo: {
    titleTemplate: '%s - Manage Group',
  },
  components: {
    DatePicker: () => import('@components/utilities/DatePicker'),
    MemberSightings: () => import('./_partials/TripSightings'),
  },
  data() {
    return {
      elementStyle,
      request: new Request(this.$refs, {
        tourism_operator_id: null,
      }),
      group: {},
      typeRequest: new TourRequest(this.$refs, {
        species: [],
        species_ids: [],
      }),
      model: new Model(),
      types: [],
      instanceOptions: {},
      elementsOptions: {},
      errors: '',
      speciesClass: 'd-none',
      loggedInUser: null,
      operators: [],
      trip: {},
      tripId: null,
      projects: [],
      isDataFetched: false,
      isEditMode: false,
      tourModel: new TourModel(),
      projectModel: new Project(),
    };
  },
  computed: {
    hasSpecies() {
      return this.request.species.length > 0;
    },
    selectedTour() {
      return this.types.find((type) => type.id === this.request.tour_id) || {};
    },
    typesByOperator() {
      return this.types.filter(
        (type) => type.user_id === this.request.tourism_operator_id
      );
    },
    validProjects() {
      const doesTourHaveProjects = this.projects.some(
        (project) => project.tour_id === this.request.tour_id
      );

      if (doesTourHaveProjects) {
        return this.projects.filter((project) => {
          if (project.tour_id) {
            return project.tour_id === this.request.tour_id;
          }
        });
      }

      const operator = this.operators.find(
        (operator) => operator.id === this.request.tourism_operator_id
      );
      return this.projects.filter((project) => {
        return operator.communityManagers
          .map((manager) => manager.id)
          .includes(project.manager_id);
      });
    },
    onlineStatus() {
      return isOnline();
    },
  },
  methods: {
    formatImageUrlFromMediaUrl,
    async submit() {
      this.request.species.length > 0 && this.request.amount > 0
        ? (this.speciesClass = 'd-none')
        : (this.speciesClass = '');
      if (await this.$refs.validator.validate()) {
        if (
          !this.request.id ||
          (this.request.id &&
            this.request.species.length &&
            this.request.amount)
        ) {
          const tours = await storage.find(StoreNames.TOURS);
          const tour = tours.find((tour) => {
            return tour.id === this.request.tour_id;
          });
          await storage.store(StoreNames.TRIPS, {
            id: this.tripId ?? uuid(),
            name: this.request.name,
            species: this.request.species,
            location: tour.location,
            amount: this.request.amount,
            check_in: this.request.check_in,
            check_out: this.request.check_out,
            tourism_operator_id: this.request.tourism_operator_id,
            tour_id: this.request.tour_id,
            tour_type_id: tour.type_id,
            project_id: this.request.project_id,
            created_at: new Date().toISOString(),
          });
          await this.$router.push({
            name: 'offline-trips',
          });
        }
      }
    },

    goToList() {
      if (this.$route.from && this.$route.from.name === 'offline-trips') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'offline-trips',
      });
    },
    async fetchOperators() {
      if (this.onlineStatus) {
        getPromise('/tourism-operators?limit=-1').then((response) => {
          this.operators = response.data;
        });

        return;
      }

      const response = await storage.find(StoreNames.OPERATORS);
      if (response) {
        this.operators = Object.values(response);
      }
    },
    async fetchTourTypes() {
      if (this.onlineStatus) {
        this.tourModel.get().then((response) => {
          this.types = response.data;
        });

        return;
      }

      let response = await storage.find(StoreNames.TOURS);
      if (response) {
        this.types = Object.values(response);
      }
    },
    async fetchProjects() {
      if (this.onlineStatus) {
        this.projectModel
          .getMinimal({
            tourism_operator_id: this.request.tourism_operator_id,
          })
          .then((response) => {
            this.projects = response.data;
          });

        return;
      }

      let response = await storage.find(StoreNames.PROJECTS);
      if (response) {
        this.projects = Object.values(response);
      }
    },
    async getLoggedInUser() {
      this.$nextTick(async () => {
        this.loggedInUser = await storage.findFirst(StoreNames.USERS);
      });
    },
    handleOperatorChange() {
      this.request.tour_id = null;
    },
    truncate(str) {
      if (!str) {
        return '';
      }

      return str.length > 100 ? str.substring(0, 100) + '...' : str;
    },
  },
  async mounted() {
    await Promise.all([
      this.fetchOperators(),
      this.fetchTourTypes(),
      this.fetchProjects(),
    ]);

    const id = this.$route.query.id;
    if (id) {
      this.isEditMode = true;
      const response = await storage.findFirst(StoreNames.TRIPS, {
        key: 'id',
        value: id,
      });
      this.tripId = id;
      if (!response) {
        await this.$router.push({
          name: 'offline-trips',
        });
      }

      Object.assign(this.trip, response);
      this.request.reinit(response);
      this.isDataFetched = true;
    }
  },
  async created() {
    await this.getLoggedInUser();
  },
};
</script>

<style lang="scss">
.stripe-payment {
  .cardElement {
    height: 44px;
    border: 2px solid #c4c4c4;
    display: flex;
    align-items: center;
    padding: 0 12px;
    border-radius: 1px;

    > * {
      width: 100%;
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
  }

  .cardNumber {
    width: 100%;
  }

  .cvc {
    max-width: 300px;
    min-width: 70px;
    width: 40%;
  }

  .expiryDate {
    max-width: 300px;
    min-width: 120px;
    width: 40%;
  }
}

#species-error {
  color: #b71c1c;
}
</style>
